import {
    FacebookAuthProvider,
    getAuth,
    GoogleAuthProvider,
    onAuthStateChanged,
    signInWithEmailAndPassword,
    signInWithPopup,
    signOut,
    User as FirebaseUser
} from "firebase/auth";
import {SecurityUser, User} from "./types/user";

function toUserFromFirebaseUser(firebaseUser: FirebaseUser | null): SecurityUser | null {
    if (firebaseUser) {
        return {
            id: firebaseUser.uid,
            email: firebaseUser.email
        };
    } else {
        return null;
    }
}

export default class AuthService {
    static isInitialized: boolean = false;
    static user: SecurityUser | null = null;

    static init() {
        AuthService.onAuthStateChanged((user: SecurityUser | null) => {
            AuthService.user = user;
            console.log("onAuthStateChanged", user);
        });
        AuthService.isInitialized = true;
    }

    static getAccessToken() {
        console.log(getAuth().currentUser);
        if (!getAuth().currentUser) {
            throw new Error("No active session");
        }
        return getAuth().currentUser!.getIdToken();
    }

    static onAuthStateChanged(callback: (user: SecurityUser | null) => void) {
        const auth = getAuth();
        onAuthStateChanged(auth, (firebaseUser: FirebaseUser | null) => {
            callback(toUserFromFirebaseUser(firebaseUser));
        });
    }

    static signInWithEmailAndPassword(email: string, password: string, callback: (isSuccess: boolean) => void) {
        const auth = getAuth();
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                console.log("login success", userCredential);
                // Signed in
                const user = userCredential.user;
                callback(true);
                // ...
            })
            .catch((error) => {
                console.error("login failed", error);
                callback(false);
            });
    }

    static signInWithGoogle(callback: (isSuccess: boolean) => void) {
        const provider = new GoogleAuthProvider();
        AuthService.signInWithPopup(provider, callback);
    }

    static signInWithFacebook(callback: (isSuccess: boolean) => void) {
        const provider = new FacebookAuthProvider();
        AuthService.signInWithPopup(provider, callback);
    }

    static signInWithPopup(provider: any, callback: (isSuccess: boolean) => void) {
        const auth = getAuth();
        signInWithPopup(auth, provider)
            .then((result) => {
                callback(true);
            }).catch((error) => {
            console.error(error);
            callback(false);
        });
    }

    static signOut(callback: () => void) {
        const auth = getAuth();
        signOut(auth).then(() => {
            // Sign-out successful.
            callback();
        }).catch((error) => {
            // An error happened.
            console.error(error);
            AuthService.user = null;
            callback();
        });
    }
}
